var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91665 5.83333H12.0833M7.91665 9.16667H12.0833M7.91665 12.5H12.0833M15 17.5V5.16667C15 4.23325 15 3.76654 14.8183 3.41002C14.6585 3.09641 14.4036 2.84144 14.09 2.68166C13.7334 2.5 13.2667 2.5 12.3333 2.5H7.66665C6.73323 2.5 6.26652 2.5 5.91 2.68166C5.59639 2.84144 5.34142 3.09641 5.18164 3.41002C4.99998 3.76654 4.99998 4.23325 4.99998 5.16667V17.5M16.6666 17.5H3.33331",
    stroke: "#ADB3BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.a0a1ead0a7a5538e35ead1bebbb87b6a.svg";
export { ForwardRef as ReactComponent };